/* eslint no-console: "off" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';

const rgbaColor = (color = {}) => `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;

const mediaQueries = {
  min30em: '@media (minWidth: 30em)',
  min40em: '@media (minWidth: 40em)',
};

const carouselContainerMedia = ({
  isSet, isReversing, direction, visibleItems = 3,
}) => {
  const TRANSLATE = direction === 'column' ? 'translateY' : 'translateX';
  const leftSign = !isReversing ? '-' : '';
  const transformSign = isReversing ? '-' : '';
  const transform = isSet ? 'none' : `${TRANSLATE}(${transformSign}${100 / visibleItems}%)`;

  // TODO: responsive
  const flexBasis = `${(1 / parseInt(visibleItems, 10)) * 100}%`;

  const media = {
    [mediaQueries.min30em]: {
      left: isReversing ? 0 : `${leftSign}50%`,
      transform: isSet ? 'none' : `${TRANSLATE}(${transformSign}50%)`,
    },
    [mediaQueries.min40em]: {
      left: isReversing ? 0 : `${leftSign}${flexBasis}`,
      transform: isSet ? 'none' : `${TRANSLATE}(${transformSign}${flexBasis})`,
    },
  };
  return { transform, ...media };
};

const CarouselContainer = (props) => {
  const {
    isSet,
    isReversing,
    visibleItems,
    direction,
    ...rest
  } = props;

  const media = carouselContainerMedia({
    isSet, isReversing, direction, visibleItems,
  });

  const transition = isSet ? 'transform 1.5s cubic-bezier(0.23, 1, 0.32, 1)' : 'none';
  const style = {
    display: 'flex',
    flexDirection: direction,
    left: '-100%',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    height: '100%',
    maxHeight: '100%',
    width: '100%',
    maxWidth: '100%',
    transition,
    ...media,
  };

  return (
    <ul {...rest} style={style} />
  );
};

CarouselContainer.propTypes = {
  isSet: PropTypes.string,
  isReversing: PropTypes.bool,
  visibleItems: PropTypes.number,
  direction: PropTypes.string,
};

CarouselContainer.defaultProps = {
  isSet: 'is-set',
  isReversing: false,
  visibleItems: 3,
  direction: 'row',
};

const CarouselWrapper = (props) => {
  const { direction, ...rest } = props;
  return (
    <div className={`CarouselWrapper flex flex-${direction} overflow-hidden max-h-full max-w-full w-full h-full`} {...rest} />
  );
};
CarouselWrapper.propTypes = {
  direction: PropTypes.string,
};
CarouselWrapper.defaultProps = {
  direction: 'row',
};


const CarouselItem = (props) => {
  const {
    order,
    direction,
    visibleItems = 3,
    ...rest
  } = props;
  const flexBasis = `${(1 / parseInt(visibleItems, 10)) * 100}%`;
  const maxWidth = direction === 'row' ? `${(1 / parseInt(visibleItems, 10)) * 100}%` : '100%';
  const maxHeight = direction === 'column' ? `${(1 / parseInt(visibleItems, 10)) * 100}%` : '100%';
  const style = {
    flex: '1 0 100%',
    flexDirection: direction,
    order,
    padding: '0px',
    // [mediaQueries.min40em]: {
    flexBasis,
    maxWidth,
    maxHeight,
    // },
  };
  return (
    <li style={style} {...rest} className="CarouselItem" />
  );
};
CarouselItem.propTypes = {
  order: PropTypes.number,
  direction: PropTypes.string,
  visibleItems: PropTypes.number,
};
CarouselItem.defaultProps = {
  direction: 'row',
  order: 1,
  visibleItems: 3,
};

const CarouselItemCard = (props) => {
  const { direction, ...rest } = props;
  return (
    <Paper className={`CarouselItemCard flex flex-${direction} h-full max-h-full relative bg-white justify-items-center`} {...rest} />
  );
};
CarouselItemCard.propTypes = {
  direction: PropTypes.string,
};
CarouselItemCard.defaultProps = {
  direction: 'row',
};

const CarouselItemMedia = props => (<img {...props} className="object-cover p-1 mx-auto overflow-hidden object-coverX" alt="img" />);

const CarouselItemTitle = (props) => {
  const { children } = props;
  const { overlayColor, textColor } = props;
  const style = {
    backgroundColor: rgbaColor(overlayColor),
    color: rgbaColor(textColor),
  };
  return (
    <div className="absolute bottom-0 w-full p-2 text-white" style={style}>
      {children}
    </div>
  );
};
CarouselItemTitle.propTypes = {
  children: PropTypes.node.isRequired,
  overlayColor: PropTypes.object,
  textColor: PropTypes.object,
};

CarouselItemTitle.defaultProps = {
  overlayColor: {
    r: 28, g: 157, b: 190, a: 0.7,
  },
  textColor: {
    r: 255, g: 255, b: 255, a: 1,
  },
};

const FlexCarouselItem = (props) => {
  const {
    item,
    index,
    len,
    order,
    visibleItems,
    overlayColor,
    textColor,
    showTitle = true,
    showDescription = true,
    backgroundColor,
    direction,
  } = props;
  const itemOrder = order >= 0 ? (index - (order + 1 + len)) % len : 2;
  return (
    <CarouselItem order={itemOrder} visibleItems={parseInt(visibleItems, 10)} direction={direction}>
      <CarouselItemCard
        zDepth={5}
        style={{ backgroundColor: rgbaColor(backgroundColor) }}
        direction={direction}
      >
        <CarouselItemMedia
          src={item.url || item.photoURL}
          alt=""
        />
        {(showDescription || showTitle) && (
          <CarouselItemTitle textColor={textColor} overlayColor={overlayColor} >
            {showTitle && (<h1>{item.title}</h1>)}
            {showDescription && (<p>{item.description}</p>)}
          </CarouselItemTitle>
        )}
      </CarouselItemCard>
    </CarouselItem>
  );
};
FlexCarouselItem.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  len: PropTypes.number,
  order: PropTypes.number,
  visibleItems: PropTypes.number,
  overlayColor: PropTypes.object,
  textColor: PropTypes.object,
  showTitle: PropTypes.bool,
  showDescription: PropTypes.bool,
  backgroundColor: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  direction: PropTypes.string,
};
FlexCarouselItem.defaultProps = {
  item: {},
  index: 0,
  len: 0,
  order: 0,
  visibleItems: 1,
  overlayColor: {},
  textColor: {},
  showTitle: true,
  showDescription: true,
  backgroundColor: {},
  direction: 'row',
};


class FlexCarousel extends Component {
  constructor(props) {
    const { reverseDirection = false, autoplay } = props;
    const safeAutoplay = parseInt(autoplay, 10) ? Math.max(autoplay, 1000) : 0;

    super(props);
    this.state = {
      order: 0,
      isSet: 'is-set',
      isReversing: reverseDirection,
      autoplay: safeAutoplay,
    };
    this.moveLeft = this.moveLeft.bind(this);
    this.moveRight = this.moveRight.bind(this);
    this.timer = this.timer.bind(this);
    this.triggerAnim = this.triggerAnim.bind(this);
  }

  componentDidMount() {
    this.mounted = true;

    if ((this.props.items && this.props.items.length > 1) && (this.state.autoplay > 0)) {
      setTimeout(() => this.registerTimer(), 0);
    } else {
      this.unregisterTimer();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { reverseDirection = false } = nextProps;
    const { autoplay: propsAutoplay = 0 } = nextProps;
    const autoplay = parseInt(propsAutoplay, 10);
    if (reverseDirection !== this.state.isReversing) {
      this.setState({ isReversing: reverseDirection });
    }
    const safeAutoplay = (autoplay || 0) && Math.max(autoplay || 0, 1000);

    if (!safeAutoplay) {
      this.unregisterTimer();
    } else if (parseInt(autoplay, 10) === 0) {
      this.unregisterTimer();
    }
    if (nextProps.items && nextProps.items.length <= 1) {
      this.unregisterTimer();
    } else {
      this.unregisterTimer();
      this.setState({ autoplay: safeAutoplay });
      if (safeAutoplay) {
        setTimeout(() => this.registerTimer('WillReceiveProps 283'), 0);
      }
    }
  }

  componentWillUnmount() {
    this.unregisterTimer();
    this.mounted = false;
  }

  unregisterTimer() {
    clearInterval(this.state.intervalId);
  }

  registerTimer(/* context */) {
    this.unregisterTimer();
    if (!this.mounted) return;
    if (parseInt(this.state.autoplay, 10) !== 0) {
      if (this.props.items && this.props.items.length > 1) {
        const intervalId = setInterval(this.timer, this.state.autoplay);
        this.setState({ intervalId });
      }
    }
  }

  timer() {
    if (this.props.autoplay) {
      if (this.state.isReversing) {
        this.moveLeft();
      } else {
        this.moveRight();
      }
    }
  }

  triggerAnim() {
    setTimeout(() => {
      this.setState({ isSet: 'is-set' });
    });
  }

  moveRight() {
    const order = (this.state.order + 1) % this.props.items.length;
    this.setState({
      order,
      isSet: '',
      isReversing: false,
    });
    this.triggerAnim();
  }

  moveLeft() {
    const order = this.state.order > 0 ? this.state.order - 1 : (this.props.items.length - 1);
    this.setState({
      order,
      isSet: '',
      isReversing: true,
    });
    this.triggerAnim();
  }

  render() {
    const {
      visibleItems,
      // reverseDirection,
      overlayColor,
      textColor,
      showDescription,
      showTitle,
      backgroudColorEnabled,
      backgroundColor,
      direction,
    } = this.props;
    return (
      <CarouselWrapper style={this.props.templateStyle} direction={direction}>
        <CarouselContainer
          isSet={this.state.isSet}
          isReversing={this.state.isReversing}
          visibleItems={parseInt(visibleItems || 0, 10)}
          direction={direction}
        >
          {this.props.items && this.props.items.map((item, index) => (
            <FlexCarouselItem
              key={item.key}
              item={item}
              index={index}
              len={this.props.items.length}
              order={this.state.order}
              visibleItems={parseInt(visibleItems || 0, 10)}
              overlayColor={overlayColor}
              textColor={textColor}
              showDescription={showDescription}
              showTitle={showTitle}
              backgroudColorEnabled
              backgroundColor={backgroudColorEnabled && backgroundColor}
              direction={direction}
            />))}
        </CarouselContainer>
      </CarouselWrapper>
    );
  }
}
FlexCarousel.propTypes = {
  items: PropTypes.array,
  visibleItems: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  autoplay: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  reverseDirection: PropTypes.bool,
  overlayColor: PropTypes.object,
  textColor: PropTypes.object,
  showDescription: PropTypes.bool,
  showTitle: PropTypes.bool,
  templateStyle: PropTypes.object,
  backgroudColorEnabled: PropTypes.bool,
  backgroundColor: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  direction: PropTypes.string,
};
FlexCarousel.defaultProps = {
  items: [],
  visibleItems: 1,
  autoplay: 1000,
  reverseDirection: true,
  overlayColor: {},
  textColor: {},
  showDescription: true,
  showTitle: true,
  templateStyle: {},
  backgroudColorEnabled: false,
  backgroundColor: {},
  direction: 'row',
};


const FlexCarouselFactory = direction => props => <FlexCarousel {...props} direction={direction} />;
export { FlexCarousel, FlexCarouselFactory };



// WEBPACK FOOTER //
// ./src/components/sliders/FlexCarousel.js